module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [(_vm.showHeader) ? _c('v-toolbar', {
    staticClass: "cyan darken-3",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Lista de Presença")])], 1) : _vm._e(), _vm._v(" "), (_vm.errors == false) ? _c('v-card-title', {
    staticClass: "pa-1"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "info"
    },
    on: {
      "click": _vm.loadAttendance
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("refresh")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.errors == false) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.sortedItems,
      "pagination": _vm.pagination,
      "loading": _vm.loading,
      "no-data-text": _vm.noData,
      "no-results-text": _vm.noResult,
      "rows-per-page-text": _vm.rowsPerPageT,
      "hide-actions": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: _vm.getPersonRowClass(props.item)
        }, [(_vm.$vuetify.breakpoint.mdAndUp) ? _c('td', [_vm._v(_vm._s(props.item.role))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(props.item.name) + "\n                    "), (!_vm.$vuetify.breakpoint.mdAndUp) ? [_c('br'), _vm._v(" "), _c('v-chip', {
          attrs: {
            "color": props.item.present == '1' ? 'success' : props.item.present == '0' ? 'warning' : 'error',
            "text-color": "white"
          }
        }, [_vm._v("\n                            " + _vm._s(props.item.present == '1' ? 'Presente' : props.item.present == '0' ? 'Registro pendente' :
          'Ausente') + "\n                        ")]), _vm._v(" "), (props.item.present == '1') ? _c('v-chip', {
          attrs: {
            "color": props.item.certification ? 'success' : 'warning',
            "text-color": "white"
          }
        }, [(props.item.certification) ? [_c('a', {
          attrs: {
            "href": props.item.certification.url,
            "target": "_blank"
          }
        }, [_vm._v("Certificação concluída")])] : _vm._e(), _vm._v(" "), (!props.item.certification) ? [_vm._v("Certificação pendente")] : _vm._e()], 2) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (_vm.$vuetify.breakpoint.mdAndUp) ? _c('td', [_c('v-chip', {
          attrs: {
            "color": props.item.present == '1' ? 'success' : props.item.present == '0' ? 'warning' : 'error',
            "text-color": "white"
          }
        }, [_vm._v("\n                        " + _vm._s(props.item.present == '1' ? 'Presente' : props.item.present == '0' ? 'Registro pendente' :
          'Ausente') + "\n                    ")]), _vm._v(" "), (props.item.present == '1') ? _c('v-chip', {
          attrs: {
            "color": props.item.certification ? 'success' : 'warning',
            "text-color": "white"
          }
        }, [(props.item.certification) ? [_c('a', {
          attrs: {
            "href": props.item.certification.url,
            "target": "_blank"
          }
        }, [_vm._v("Certificação concluída")])] : _vm._e(), _vm._v(" "), (!props.item.certification) ? [_vm._v("Certificação pendente")] : _vm._e()], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('td', {
          attrs: {
            "align": "center"
          }
        }, [(!_vm.readonly && props.item.present != '1') ? _c('v-btn', {
          attrs: {
            "color": "success",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Registrar presença"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.recordAttendance(props.item.id, true)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.readonly && props.item.present != '' && !props.item.certification) ? _c('v-btn', {
          attrs: {
            "color": "error",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Registrar ausência"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.recordAttendance(props.item.id, false)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("cancel")])], 1) : _vm._e()], 1)])]
      }
    }], null, false, 1405269661)
  }) : _vm._e(), _vm._v(" "), (!_vm.readonly && _vm.errors == false) ? _c('v-card-title', {
    staticClass: "pa-1"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Código",
      "prepend-icon": "person"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addAttendance.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.newAttendanceId),
      callback: function($$v) {
        _vm.newAttendanceId = $$v
      },
      expression: "newAttendanceId"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "success"
    },
    on: {
      "click": _vm.addAttendance
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" Adicionar ouvinte\n        ")], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.readonly && _vm.errors == false) ? _c('v-card-title', {
    staticClass: "pa-1"
  }, [_c('v-spacer'), _vm._v(" "), (_vm.canCertify && _vm.hasPendingCertification) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "deep-orange"
    },
    on: {
      "click": _vm.certifyAttendees
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("check")]), _vm._v(" Certificar participantes presentes\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.canCertify && _vm.hasPendingCertification) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "value": true
    }
  }, [_vm._v("A certificação dos\n            participantes\n            desta banca estará disponível após o encerramento.")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.errors != false) ? _c('v-card-title', _vm._l((_vm.errors), function(error, idx) {
    return _c('v-alert', {
      key: 'error_' + idx,
      attrs: {
        "error": "",
        "value": "true"
      }
    }, [_vm._v("\n            " + _vm._s(error) + "\n        ")])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.submitErrors != false) ? _c('v-card-title', _vm._l((_vm.submitErrors), function(error, idx) {
    return _c('v-alert', {
      key: 'error_' + idx,
      attrs: {
        "error": "",
        "value": "true"
      }
    }, [_vm._v("\n            " + _vm._s(error) + "\n        ")])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.showActions) ? _c('v-card-actions', [_vm._t("actions")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0fa186e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamAttendance.vue
// module id = 257
// module chunks = 0